<template>
	<el-tabs id="userinfoList" value="first" type="border-card">
		<el-tab-pane name="first" :label="$t('subtaskInfo')">
			<el-row>
				<el-col :xs="24">
          <el-form :model="subtaskForm" :rules="rules" ref="subtaskForm" label-width="210px">
					  <el-card >
              <el-row>
                <el-col style="text-align: right;" :xs="24" :md="24">
                  <el-button v-has="{class:'subtaskLabour'}" v-if="flagStatus=='0'&&showAdd=='0'" size="mini" type="primary" @click="addLabour">{{$t('addLabour')}}</el-button>
                </el-col>
              </el-row>
              <el-row>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskName1')" prop="taskId">
                    <el-select v-model="subtaskForm.taskId" disabled >
                      <el-option v-for="item in TaskList" :key="item.taskNumber" :label="item.taskName" :value="item.taskNumber"></el-option>
                    </el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subtaskName1')" prop="subtaskName">
										<el-input v-model="subtaskForm.subtaskName" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subtaskStatus1')" prop="subtaskStatus" >
                    <el-select v-model="subtaskForm.subtaskStatus" disabled>
											<el-option v-for="item in StatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12" style="display: flex">
                  <div style="width: 294px">
                    <el-form-item label="Actual Delivery:" prop="quantityMark" class="isEngineerGroupItem">
                      <el-select v-model="subtaskForm.quantityMark" disabled>
                        <el-option :key="0" label="Engineer" :value="0"></el-option>
                        <el-option :key="1" label="Group" :value="1"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
									<div :style="{ 'display': subtaskForm.quantityMark === 0 ? '' : 'none', 'wdith': '187px'}">
                    <el-form-item label="" prop="actualDeliveryEngineer" label-width="0" class="engineerGroupItem" style="width: 187px">
                      <el-select v-model="subtaskForm.actualDeliveryEngineer" disabled>
                        <el-option v-for="item in SubtaskOwnerList" :key="item.empCode" :label="item.userCode" :value="item.empCode"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>

                  <div :style="{ 'display': subtaskForm.quantityMark === 1 ? '' : 'none', 'wdith': '187px'}">
                    <el-form-item label="" prop="groupId" label-width="0" class="engineerGroupItem groupItem" style="width: 187px">
                      <el-select v-model="subtaskForm.groupId" disabled>
                        <el-option v-for="(item) in groupData" :key="item.id" :label="item.sysValue" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
								</el-col>
                <!-- <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subtaskDeliveryType1')" >
                    <el-input v-model="subtaskForm.subtaskDeliveryType" disabled />
									</el-form-item>
								</el-col> -->
              </el-row>
              <el-row v-if="showLeave == 0">
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('plannedLabourHour1')" prop="plannedLabourHour">
                    <el-input v-model="subtaskForm.plannedLabourHour" disabled/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveredLabourHour1')" prop="deliveredLabourHour" >
                    <el-input v-model="subtaskForm.deliveredLabourHour" disabled/>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row v-if="showLeave == 0">
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryEngineerCity1')">
                    <el-input v-model="subtaskForm.deliveryEngineerCity" disabled/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryAddress1')" >
                    <el-input v-model="subtaskForm.deliveryAddress" disabled/>
									</el-form-item>
								</el-col>
              </el-row>
							<!-- <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subtaskEstimatedStartDate1')" prop="subtaskEstimatedStartDate">
										<el-date-picker v-model="subtaskForm.subtaskEstimatedStartDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subtaskEstimatedEndDate1')" prop="subtaskEstimatedEndDate">
										<el-date-picker v-model="subtaskForm.subtaskEstimatedEndDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
              </el-row> -->
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceStartDate1')" prop="serviceStartDate">
                    <el-date-picker v-model="subtaskForm.serviceStartDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceEndDate1')" prop="serviceEndDate">
                    <el-date-picker v-model="subtaskForm.serviceEndDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row v-if="showLeave == 1">
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveredLabourHour2')" prop="deliveredLabourHour" >
                    <el-input v-model="subtaskForm.deliveredLabourHour" disabled/>
									</el-form-item>
								</el-col>
              </el-row>
              <!-- <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('plannedDate1')" prop="plannedDate">
										<el-date-picker v-model="subtaskForm.plannedDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryFinishedDate1')" prop="deliveryFinishedDate">
										<el-date-picker v-model="subtaskForm.deliveryFinishedDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
							</el-row> -->
							<el-row v-if="showLeave == 0">
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('isStationin1')" >
                    <el-select v-model="subtaskForm.isStationin" disabled>
											<el-option v-for="item in IsStationinList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <!-- <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subtaskCompletion1')" >
                    <el-select v-model="subtaskForm.subtaskCompletion" disabled>
											<el-option v-for="item in TaskCompletionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col> -->
							</el-row>
              <el-row v-if="showLeave == 0">
                <el-col :xs="24" :md="12">
                  <!-- <el-form-item :label="$t('subtaskReport1')"  >
                    <a style="cursor:pointer;color:blue;" @click="handleOpenUrl(fileAliasName,fileName)">{{fileName}}</a>
                  </el-form-item> -->
                  <el-form-item :label="$t('subtaskReport1')"  >
                    <el-upload action="" :file-list="fileList" :on-preview="handlePreview" disabled>
                      <span>{{'Click the file name to download'}}</span>
                    </el-upload>
                  </el-form-item>
								</el-col>
              </el-row>
              <el-row v-if="this.$route.params.showRun=='Y'">
                <el-col style="margin-top: 10px; text-align: center;" :xs="24" :md="24">
                  <el-button type="primary" size="medium" @click="returnList">{{$t('return')}}</el-button>
                </el-col>
              </el-row>
            </el-card>
          </el-form>
				</el-col>
			</el-row>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
    import {_debounce} from '@/utils/selectAPI'
    import * as validate from '@/utils/validate'
    export default {
        created () {
          this.getTaskList();
          this.getSubtaskData();
          this.getGroupList();
        },
        data () {
          return {
            rangeNumber: 10,
            subtaskForm: {
              projectId:null,
              taskId:null,
              taskType:null,
              subtaskName:null,
              subtaskType:null,
              subtaskStatus:null,
              plannedLabourHour:null,
              deliveredLabourHour:null,
              quantityMark: 0,
              actualDeliveryEngineer:null,
              groupId:null,
              deliveryEngineerCity:null,
              deliveryAddress:null,
              subtaskEstimatedStartDate:null,
              subtaskEstimatedEndDate:null,
              serviceStartDate:null,
              serviceEndDate:null,
              plannedDate:null,
              deliveryFinishedDate:null,
              isStationin:null,
              subtaskDeliveryType:null,
              subtaskReport:null,
              subtaskRemark:null,
            },
            showLeave:0,
            reportArr:[],
            fileList:[],
            flagStatus:1,
            showAdd:1,
            SubtaskOwnerList:[],
            TaskList:[],
            TSList:[],
            StatusList:[
              { value: 'ToDelivered',label: 'Waiting for Delivery'},
              { value: 'Delivered',label: 'Delivering'},
              { value: 'DeliveryCompleted',label: 'Fully Delivered'},
              { value: 'Frozen',label: 'Frozen'},
              { value: 'Closed',label: 'Closed'},
            ],
            IsStationinList:[
              { value: 'Yes',label: 'Yes'},
              { value: 'No',label: 'No'},
            ],
            TaskCompletionList:[
              { value: 'uncomplete',label: '未完成'},
              { value: 'completed',label: '完成'},
            ],
            groupData: [],
            rules: {
              taskId: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              subtaskName: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              subtaskType: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              quantityMark: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              actualDeliveryEngineer: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              groupId: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              subtaskStatus: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              plannedLabourHour: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              deliveredLabourHour: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              subtaskEstimatedStartDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              subtaskEstimatedEndDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              serviceStartDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              serviceEndDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              plannedDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              deliveryFinishedDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
            }
          } 
        },
        methods: {
          getTaskList(){
            let url =`${this.$store.state.islhurl}task/getSelectTaskToDetail`;
            this._get(url).then(
              res => {   
                this.TSList = res.data;
              }
            )
          },
          getGroupList(){
            let url = `${this.$store.state.islhurl}getGroupList/999/1`
            let pm = {
              delStatus: 0, 
              islhToken: sessionStorage.getItem('islhtoken')
            }
            this._post(url,pm).then(
              res =>{
                this.groupData = res.data;
              }
            )
          },
          //回显数据
          getSubtaskData(){
            let pm = {};
            let subtaskId = this.$route.params.subtaskNumber;
            if(subtaskId != undefined && subtaskId != null && subtaskId != ''){
              pm = {
                subtaskNumber: subtaskId,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
            }else{
              pm = {
                id: this.$route.params.id,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
            }
            // console.log(pm);
            let url = `${this.$store.state.islhurl}subtask/getInfo`
            this._post(url,pm).then(
              res =>{
                //先加载下拉选项
                setTimeout(() => {
                  this.filterUserCode(res.subtask.actualDeliveryEngineer);
                }, 2000);
                setTimeout(() => {
                  this.filterTaskCode(res.subtask.taskId);
                }, 800);
                //再进行赋值
                this.subtaskForm = res.subtask;
                this.subtaskForm.quantityMark = res.subtask.quantityMark || 0;
                this.flagStatus = res.subtask.flagStatus;
                this.showAdd = res.subtask.showAdd;
                if(res.subtask.subtaskDeliveryType == 'Personal Leave'){
                  this.showLeave = 1;
                }else{
                  this.showLeave = 0;
                }
                //若有附件，显示附件名称
                if(res.subtask.subtaskReport != null && res.subtask.subtaskReport != 0){
                  let reportAy = res.subtask.subtaskReport.split(",");
                  reportAy.forEach(item => {
                    let params = {
                      id: item,
                      islhToken : sessionStorage.getItem('islhtoken'),
                    }
                    let url =`${this.$store.state.islhurl}attachment/getInfo`;
                    this._post(url, params).then(
                      res =>{
                        this.fileList.push({name: res.attachment.fileName, url: res.attachment.fileAliasName});
                        this.reportArr.push({aid: res.attachment.id, fileurl: res.attachment.fileAliasName});
                      }
                    )
                  });
                }
              }
            )
          },
          handlePreview(file){
            let url =`${this.$store.state.islhurl}download?fileAliasName=${file.url}&fileName=${file.name}`
            window.open(url);
          },
          addLabour() {
            // let pm = {
            //   subtaskNumber: this.subtaskForm.subtaskNumber,
            // }
            // this.$router.push({name:'labour_add',params:pm})
            let url =`${this.$store.state.islhurl}subtask/getSubtaskToHour`;
            let pm = {
              subtaskNumber : this.subtaskForm.subtaskNumber,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res => {
                if (res.subtask) {
                  let obj = {
                    ...res.subtask
                  }
                  this.$router.push({name:'labourEnter',params:obj});
                  this.$store.commit('tagChange', 'labourEnter');
                }
              }
            )
          },
          returnList(){
            let pm = this.$route.params;
            this.$router.push({name:'subtask',params:pm});
          },
          filterUserCode(filterVal){
            if (filterVal) {
              let url =`${this.$store.state.islhurl}user/batch-get`;
              let obj = {
                empCodeList: [filterVal]
              }
              this._post(url, obj).then(
                res => {  
                  if(res.code === 200 && res.data) {
                    this.SubtaskOwnerList = res.data
                  }
                }
              )
            }
          },
          filterTaskCode(filterVal){
            if(filterVal){
              let filterArr = this.TSList.filter(item => {
                return item.taskNumber.toLowerCase().indexOf(filterVal.toLowerCase()) > -1;
              })
              this.TaskList = filterArr;
            }else{
              this.TaskList = this.TSList;
            }
          },
        },
    }
</script>


// WEBPACK FOOTER //
// src/view/subtask/subtaskDetail.vue